<div class="back" *ngIf="hasBackButton" (click)="onClickBack()"><i class="lvi-icon-chevron-left"></i> Retour</div>
<div *ngIf="hasBackButton">|</div>
<ol *ngIf="title">
  <li>
    <a href="/">
      <span><i class="lvi-thel-accueil"></i></span>
    </a>
  </li>
  <li >
    /
    <span>
      <span>{{title|stripTags}}</span></span>
  </li>
</ol>
<ol *ngIf="!title" itemscope itemtype="https://schema.org/BreadcrumbList">
  <li>
    <a href="/">
      <span><i class="lvi-thel-accueil"></i></span>
    </a>
  </li>
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
    <ng-container *ngIf="breadcrumb.text">
      /
      <li itemprop="itemListElement" itemscope
          itemtype="https://schema.org/ListItem">
        <a itemprop="item" [routerLink]="breadcrumb.url">
          <span itemprop="name" [innerHTML]="breadcrumb.text|stripTags"></span></a>
        <meta itemprop="position" content="{{i+1}}" />
      </li>
    </ng-container>
  </ng-container>
</ol>
